import { render } from "./NotesApp.vue?vue&type=template&id=7707ec98&scoped=true"
import script from "./NotesApp.vue?vue&type=script&lang=js"
export * from "./NotesApp.vue?vue&type=script&lang=js"

import "./NotesApp.vue?vue&type=style&index=0&id=7707ec98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7707ec98"]])

export default __exports__